import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Subject, concat, map, of, switchMap, timer } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { IconButtonSize, IconButtonTheme } from '../buttons';

const COPIED_RESET_MS = 2000;

@Component({
  selector: 'fin-copy-text',
  templateUrl: './copy-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CopyTextComponent {
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly IconButtonTheme = IconButtonTheme;

  value = input.required<string>();
  ariaLabel = input.required<string>();
  copiedLabel = input.required<string>();
  size = input<IconButtonSize>(IconButtonSize.SMALL);

  private readonly copySucceeded = new Subject<void>();

  protected readonly copied = toSignal(
    this.copySucceeded.pipe(switchMap(() => concat(of(true), timer(COPIED_RESET_MS).pipe(map(() => false))))),
    { initialValue: false }
  );

  copy(): Promise<void> {
    const value = this.value();

    if (!navigator.clipboard || !value) {
      return Promise.resolve();
    }

    return navigator.clipboard
      .writeText(value)
      .then(() => this.copySucceeded.next())
      .catch(() => undefined);
  }
}
